import React from 'react';
import Layout from '../components/layout';
import SEO from '../components/seo';
import Head from '../components/globals/Head';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';
import { Link } from 'gatsby';
import '../components/GalleryPageComponents/Gallery.css';

const Gallery = (props) => (
	<Layout>
		<SEO title="Gallery" keywords={[ `masu`, `design`, `front-end web developing` ]} />
		<Head />
		<div className="container">
			<div class="container-label">
				<div className="gallery-label">
					<h3>Flyers</h3>
				</div>
			</div>
			<div className={'wrap-gallery'}>
				<div className={'wrap-gallery-images'}>
					<Link className={'gallery-img'} to="/image-kontakt/">
						<Img
							style={{
								width: '100%'
							}}
							alt="two hands in touch on blue background with with title kontakt"
							fluid={props.data.imageContact.childImageSharp.fluid}
						/>
					</Link>
					<Link className={'gallery-img'} to="/image-power/">
						<Img
							style={{ width: '100%' }}
							alt="red backgrond with blue flowers and title power of loving"
							fluid={props.data.imagePower.childImageSharp.fluid}
						/>
					</Link>
					<Link className={'gallery-img'} to="/image-momentum/">
						<Img
							style={{
								width: '100%'
							}}
							alt="black and grey background with blue dot and title momentum"
							fluid={props.data.imageMomentum.childImageSharp.fluid}
						/>
					</Link>
					<Link className={'gallery-img'} to="/image-whole/">
						<Img
							style={{
								width: '100%'
							}}
							alt="tourquise background with red title wholeness"
							fluid={props.data.imageWhole.childImageSharp.fluid}
						/>
					</Link>
				</div>
			</div>
			<div className={'wrap-gallery'}>
				<div className={'wrap-gallery-images'}>
					<Link className={'gallery-img'} to="/image-intimacy/">
						<Img
							style={{ width: '100%' }}
							alt="red background with two human head silhouettes and title intimacy"
							fluid={props.data.imageIntimacy.childImageSharp.fluid}
						/>
					</Link>
					<Link className={'gallery-img'} to="/image-quot/">
						<Img
							style={{ width: '100%' }}
							alt="tourquise background with black silhouette and title quotidiennete"
							fluid={props.data.imageQuot.childImageSharp.fluid}
						/>
					</Link>
					<Link className={'gallery-img'} to="/image-quotidiennete/">
						<Img
							style={{ width: '100%' }}
							alt="black and white photography of trees with title quotidiennete"
							fluid={props.data.imageQuotMono.childImageSharp.fluid}
						/>
					</Link>
					<Link className={'gallery-img'} to="/image-behind/">
						<Img
							style={{ width: '100%' }}
							alt="blue background with title behind the corner"
							fluid={props.data.imageBehind.childImageSharp.fluid}
						/>
					</Link>
				</div>
			</div>
			<div className={'wrap-gallery'}>
				<div className={'wrap-gallery-images'}>
					<Link className={'gallery-img'} to="/image-play/">
						<Img
							style={{ width: '100%' }}
							alt="brown background with books in different colors and title play knowledge"
							fluid={props.data.imagePlay.childImageSharp.fluid}
						/>
					</Link>
					<Link className={'gallery-img'} to="/image-gold/">
						<Img
							style={{ width: '100%' }}
							alt="gray background un different shades with title golden tutoring"
							fluid={props.data.imageGold.childImageSharp.fluid}
						/>
					</Link>
					<Link className={'gallery-img'} to="/image-poetry/">
						<Img
							style={{ width: '100%' }}
							alt="red background with green stripe and geometry shape and title the poetry of geometry"
							fluid={props.data.imagePoetry.childImageSharp.fluid}
						/>
					</Link>
					<Link className={'gallery-img'} to="/image-3d/">
						<Img
							style={{ width: '100%' }}
							alt="gray background with geometry patterns in different colors and number three and title number three"
							fluid={props.data.image3D.childImageSharp.fluid}
						/>
					</Link>
				</div>
			</div>
			<div class="container-label">
				<div className="gallery-label1">
					<h3>Labels</h3>
				</div>
			</div>
			<div className={'wrap-gallery'}>
				<div className={'wrap-gallery-images'}>
					<Link className={'gallery-img'} to="/image-label-il-vasaio/">
						<Img
							style={{ width: '100%' }}
							alt="golden background with bottle and title il vasaio"
							fluid={props.data.imageLabelA.childImageSharp.fluid}
						/>
					</Link>
					<Link className={'gallery-img'} to="/image-label-podere/">
						<Img
							style={{ width: '100%' }}
							alt="gray background with leaf veins and brown title podere la semplice canzone"
							fluid={props.data.imageLabelB.childImageSharp.fluid}
						/>
					</Link>
					<Link className={'gallery-img'} to="/image-label-podere-2014/">
						<Img
							style={{ width: '100%' }}
							alt="white background with stylized branches with title podere la semplice canzone"
							fluid={props.data.imageLabelC.childImageSharp.fluid}
						/>
					</Link>
					<Link className={'gallery-img'} to="/image-label-bottles/">
						<Img
							style={{ width: '100%' }}
							alt="white background with four black and white bottles"
							fluid={props.data.imageLabelD.childImageSharp.fluid}
						/>
					</Link>
				</div>
			</div>
			<div class="container-label">
				<div className="gallery-label1">
					<h3>Stained glass</h3>
				</div>
			</div>
			<div className={'wrap-gallery'}>
				<div className={'wrap-gallery-images'} style={{ marginBottom: '20px' }}>
					<Link className={'gallery-img'} to="/image-stained-glassA/">
						<Img
							style={{ width: '100%' }}
							alt="stylized sea with two old ships and dragon"
							fluid={props.data.imageVitrayA.childImageSharp.fluid}
						/>
					</Link>
					<Link className={'gallery-img'} to="/image-stained-glassB/">
						<Img
							style={{ width: '100%' }}
							alt="stylized sea with ships"
							fluid={props.data.imageVitrayB.childImageSharp.fluid}
						/>
					</Link>
					<Link className={'gallery-img'} to="/image-stained-glassC/">
						<Img
							style={{ width: '100%' }}
							alt="stylized sea with ships"
							fluid={props.data.imageVitrayC.childImageSharp.fluid}
						/>
					</Link>
					<Link className={'gallery-img'} to="/image-stained-glassD/">
						<Img
							style={{ width: '100%' }}
							alt="stylized sea with ships"
							fluid={props.data.imageVitrayD.childImageSharp.fluid}
						/>
					</Link>
				</div>
			</div>
		</div>
	</Layout>
);

export default Gallery;

export const fluidImage = graphql`
	fragment fluidImage on File {
		childImageSharp {
			fluid(maxWidth: 1000) {
				...GatsbyImageSharpFluid_withWebp
			}
		}
	}
`;

export const pageQuery = graphql`
	query {
		imageContact: file(relativePath: { eq: "Contact-opt.jpg" }) {
			...fluidImage
		}
		imagePower: file(relativePath: { eq: "Power-opt.jpg" }) {
			...fluidImage
		}
		imageMomentum: file(relativePath: { eq: "Momentum-opt.jpg" }) {
			...fluidImage
		}
		imageWhole: file(relativePath: { eq: "Whole-opt.jpg" }) {
			...fluidImage
		}
		imageIntimacy: file(relativePath: { eq: "Intimacy-opt.jpg" }) {
			...fluidImage
		}
		imageQuot: file(relativePath: { eq: "Quot-opt.jpg" }) {
			...fluidImage
		}
		imageQuotMono: file(relativePath: { eq: "QuotMono-opt.jpg" }) {
			...fluidImage
		}
		imageBehind: file(relativePath: { eq: "Behind-opt.jpg" }) {
			...fluidImage
		}
		imagePlay: file(relativePath: { eq: "Play-opt.jpg" }) {
			...fluidImage
		}
		imageGold: file(relativePath: { eq: "Gold-opt.jpg" }) {
			...fluidImage
		}
		imagePoetry: file(relativePath: { eq: "Poetry-opt.jpg" }) {
			...fluidImage
		}
		image3D: file(relativePath: { eq: "3D-opt.png" }) {
			...fluidImage
		}
		imageLabelA: file(relativePath: { eq: "L-A-opt.png" }) {
			...fluidImage
		}
		imageLabelB: file(relativePath: { eq: "L-B-opt.jpg" }) {
			...fluidImage
		}
		imageLabelC: file(relativePath: { eq: "L-C-opt.jpg" }) {
			...fluidImage
		}
		imageLabelD: file(relativePath: { eq: "L-D-opt.jpg" }) {
			...fluidImage
		}
		imageVitrayA: file(relativePath: { eq: "Vitraj-A-opt.jpg" }) {
			...fluidImage
		}
		imageVitrayB: file(relativePath: { eq: "Vitraj-B-opt.jpg" }) {
			...fluidImage
		}
		imageVitrayC: file(relativePath: { eq: "Vitraj-C-opt.jpg" }) {
			...fluidImage
		}
		imageVitrayD: file(relativePath: { eq: "Vitraj-D-opt.jpg" }) {
			...fluidImage
		}
	}
`;
